"use strict";
/* Generated from:
 * ap-northeast-1 (https://d33vqc0rt9ld30.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-2 (https://d1ane3fvebulky.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-3 (https://d2zq80gdmjim8k.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-south-1 (https://d2senuesg1djtx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-1 (https://doigdx0kgq9el.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-2 (https://d2stg8d246z9di.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ca-central-1 (https://d2s8ygphhesbe7.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-central-1 (https://d1mta8qj7i28i2.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-1 (https://d3teyb21fexa9r.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-2 (https://d1742qcu2c1ncx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-3 (https://d2d0mfegowb3wk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * sa-east-1 (https://d3c9jyj3w509b0.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-1 (https://d1uauaxba7bl26.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-2 (https://dnwj8swjjbsbt.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-1 (https://d68hl49wbnanq.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-2 (https://d201a2mn26r7lk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = require("../resource");
class OwnershipControls {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.OwnershipControls = OwnershipControls;
class ReplicaModifications {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ReplicaModifications = ReplicaModifications;
class CorsRule {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CorsRule = CorsRule;
class Destination {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Destination = Destination;
class OwnershipControlsRule {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.OwnershipControlsRule = OwnershipControlsRule;
class AccessControlTranslation {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AccessControlTranslation = AccessControlTranslation;
class VersioningConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VersioningConfiguration = VersioningConfiguration;
class ReplicationTime {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ReplicationTime = ReplicationTime;
class ServerSideEncryptionByDefault {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ServerSideEncryptionByDefault = ServerSideEncryptionByDefault;
class Tiering {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Tiering = Tiering;
class SseKmsEncryptedObjects {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SseKmsEncryptedObjects = SseKmsEncryptedObjects;
class QueueConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.QueueConfiguration = QueueConfiguration;
class ObjectLockConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ObjectLockConfiguration = ObjectLockConfiguration;
class AccelerateConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AccelerateConfiguration = AccelerateConfiguration;
class IntelligentTieringConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.IntelligentTieringConfiguration = IntelligentTieringConfiguration;
class AbortIncompleteMultipartUpload {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AbortIncompleteMultipartUpload = AbortIncompleteMultipartUpload;
class DeleteMarkerReplication {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DeleteMarkerReplication = DeleteMarkerReplication;
class PublicAccessBlockConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.PublicAccessBlockConfiguration = PublicAccessBlockConfiguration;
class ReplicationRule {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ReplicationRule = ReplicationRule;
class SourceSelectionCriteria {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SourceSelectionCriteria = SourceSelectionCriteria;
class StorageClassAnalysis {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.StorageClassAnalysis = StorageClassAnalysis;
class RedirectRule {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RedirectRule = RedirectRule;
class ObjectLockRule {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ObjectLockRule = ObjectLockRule;
class Rule {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Rule = Rule;
class MetricsConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MetricsConfiguration = MetricsConfiguration;
class DataExport {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DataExport = DataExport;
class ReplicationTimeValue {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ReplicationTimeValue = ReplicationTimeValue;
class FilterRule {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.FilterRule = FilterRule;
class ReplicationRuleAndOperator {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ReplicationRuleAndOperator = ReplicationRuleAndOperator;
class BucketEncryption {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.BucketEncryption = BucketEncryption;
class Metrics {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Metrics = Metrics;
class RoutingRuleCondition {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RoutingRuleCondition = RoutingRuleCondition;
class LifecycleConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.LifecycleConfiguration = LifecycleConfiguration;
class NotificationConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.NotificationConfiguration = NotificationConfiguration;
class RedirectAllRequestsTo {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RedirectAllRequestsTo = RedirectAllRequestsTo;
class S3KeyFilter {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.S3KeyFilter = S3KeyFilter;
class InventoryConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InventoryConfiguration = InventoryConfiguration;
class ReplicationConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ReplicationConfiguration = ReplicationConfiguration;
class CorsConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CorsConfiguration = CorsConfiguration;
class ReplicationDestination {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ReplicationDestination = ReplicationDestination;
class NoncurrentVersionTransition {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.NoncurrentVersionTransition = NoncurrentVersionTransition;
class DefaultRetention {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DefaultRetention = DefaultRetention;
class NotificationFilter {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.NotificationFilter = NotificationFilter;
class LambdaConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.LambdaConfiguration = LambdaConfiguration;
class ServerSideEncryptionRule {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ServerSideEncryptionRule = ServerSideEncryptionRule;
class AnalyticsConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AnalyticsConfiguration = AnalyticsConfiguration;
class LoggingConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.LoggingConfiguration = LoggingConfiguration;
class RoutingRule {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RoutingRule = RoutingRule;
class EncryptionConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.EncryptionConfiguration = EncryptionConfiguration;
class WebsiteConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.WebsiteConfiguration = WebsiteConfiguration;
class TopicConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TopicConfiguration = TopicConfiguration;
class TagFilter {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TagFilter = TagFilter;
class Transition {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Transition = Transition;
class ReplicationRuleFilter {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ReplicationRuleFilter = ReplicationRuleFilter;
class Bucket extends resource_1.ResourceBase {
    constructor(properties) {
        super('AWS::S3::Bucket', properties || {});
    }
}
exports.default = Bucket;
Bucket.OwnershipControls = OwnershipControls;
Bucket.ReplicaModifications = ReplicaModifications;
Bucket.CorsRule = CorsRule;
Bucket.Destination = Destination;
Bucket.OwnershipControlsRule = OwnershipControlsRule;
Bucket.AccessControlTranslation = AccessControlTranslation;
Bucket.VersioningConfiguration = VersioningConfiguration;
Bucket.ReplicationTime = ReplicationTime;
Bucket.ServerSideEncryptionByDefault = ServerSideEncryptionByDefault;
Bucket.Tiering = Tiering;
Bucket.SseKmsEncryptedObjects = SseKmsEncryptedObjects;
Bucket.QueueConfiguration = QueueConfiguration;
Bucket.ObjectLockConfiguration = ObjectLockConfiguration;
Bucket.AccelerateConfiguration = AccelerateConfiguration;
Bucket.IntelligentTieringConfiguration = IntelligentTieringConfiguration;
Bucket.AbortIncompleteMultipartUpload = AbortIncompleteMultipartUpload;
Bucket.DeleteMarkerReplication = DeleteMarkerReplication;
Bucket.PublicAccessBlockConfiguration = PublicAccessBlockConfiguration;
Bucket.ReplicationRule = ReplicationRule;
Bucket.SourceSelectionCriteria = SourceSelectionCriteria;
Bucket.StorageClassAnalysis = StorageClassAnalysis;
Bucket.RedirectRule = RedirectRule;
Bucket.ObjectLockRule = ObjectLockRule;
Bucket.Rule = Rule;
Bucket.MetricsConfiguration = MetricsConfiguration;
Bucket.DataExport = DataExport;
Bucket.ReplicationTimeValue = ReplicationTimeValue;
Bucket.FilterRule = FilterRule;
Bucket.ReplicationRuleAndOperator = ReplicationRuleAndOperator;
Bucket.BucketEncryption = BucketEncryption;
Bucket.Metrics = Metrics;
Bucket.RoutingRuleCondition = RoutingRuleCondition;
Bucket.LifecycleConfiguration = LifecycleConfiguration;
Bucket.NotificationConfiguration = NotificationConfiguration;
Bucket.RedirectAllRequestsTo = RedirectAllRequestsTo;
Bucket.S3KeyFilter = S3KeyFilter;
Bucket.InventoryConfiguration = InventoryConfiguration;
Bucket.ReplicationConfiguration = ReplicationConfiguration;
Bucket.CorsConfiguration = CorsConfiguration;
Bucket.ReplicationDestination = ReplicationDestination;
Bucket.NoncurrentVersionTransition = NoncurrentVersionTransition;
Bucket.DefaultRetention = DefaultRetention;
Bucket.NotificationFilter = NotificationFilter;
Bucket.LambdaConfiguration = LambdaConfiguration;
Bucket.ServerSideEncryptionRule = ServerSideEncryptionRule;
Bucket.AnalyticsConfiguration = AnalyticsConfiguration;
Bucket.LoggingConfiguration = LoggingConfiguration;
Bucket.RoutingRule = RoutingRule;
Bucket.EncryptionConfiguration = EncryptionConfiguration;
Bucket.WebsiteConfiguration = WebsiteConfiguration;
Bucket.TopicConfiguration = TopicConfiguration;
Bucket.TagFilter = TagFilter;
Bucket.Transition = Transition;
Bucket.ReplicationRuleFilter = ReplicationRuleFilter;
